/* ============
 * sold product
 * ============
 *
 * This is Line chart.
 */
import { mapGetters } from 'vuex';
import userWidgetsService from './../../../services/widgets';
import LineChart from './../../widgetsChart/line/line.vue';

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      lineColor: ['#073b4c', '#118ab2', '#06d6a0', '#ffd166', '#ef476f'],
      options: {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0, right: 0, top: 0, bottom: 0,
          },
        },
        legend: {
          display: true,
          position: 'left',
          labels: {
            boxWidth: 4,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: ((tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].tooltip} - ${tooltipItem.yLabel}`),
          },
        },
      },
      chartdata: {
        labels: [],
        datasets: [],
      },
      loaded: false,
      filterBy: [
          { label: this.$t('static.widgets.soldProduct.filters.last3Months'), value: 'last_3_months' },
          { label: this.$t('static.widgets.soldProduct.filters.last6Months'), value: 'last_6_months' },
          { label: this.$t('static.widgets.soldProduct.filters.thisYear'), value: 'this_year' },
      ],
      filterBySelected: 'last_3_months',
      monthNumber: 3,
      monthStart: 1,
    };
  },

  computed: {
    ...mapGetters({
      soldProductsWidgets: 'soldProductsWidgets',
    }),
  },

  methods: {

    updateChart(value) {
      this.monthStart = 1;
      if (value === 'last_3_months') {
        this.monthNumber = 3;
      } else if (value === 'last_6_months') {
        this.monthNumber = 6;
      } else {
        this.monthStart = 0;
        this.monthNumber = parseInt(new Date().getMonth());
      }
      this.initializeWidgets(value);
    },

    soldProd(soldProdWidgets) {
      const self = this;
      const tempData = [];
      const tempData2 = [];
      const tempData5 = [];
      const tempDataLabels = [];
      this.chartdata.labels = [];
      this.chartdata.datasets = [];

      /** Assign the filter by months */
      this.getFilterBy(this.monthNumber).forEach((item) => {
        tempData5[new Date(Date.parse(`${item} 1, 2020`)).getMonth() + 1] = item;
      });

            // this.chartdata.labels = [];
      tempData5.forEach((item) => { tempDataLabels.push(item); });
      tempDataLabels.forEach((item) => { tempData2[item] = 0; });

            /** Looping the products, it contains product name and total qty amount */
      soldProdWidgets.top.forEach((item, key) => {
        const tempData3 = [];
        const tempData4 = [];

              /** This will reset the value of every product */
        for (let i = 0; i <= self.monthNumber; i++) {
          tempData2[self.getFilterBy(self.monthNumber)[i]] = 0;
        }

        soldProdWidgets.data.forEach((item2) => {
          if (item.product_id === item2.product_id) tempData2[item2.month] += item2.qty;
        });

              /** This will add to object */
        tempData3.push(tempData2);
        const values = Object.entries(tempData3[0]);
        for (const value of values) { tempData4.push(value[1]); }

        if (tempData4.length > 0) {
          tempData.push({
            tooltip: item.name,
            label: (item.name.length <= 9) ? item.name : `${item.name.substring(0, 6)}...`,
            borderColor: self.lineColor[key],
            backgroundColor: self.colorOpacity(self.lineColor[key], 0.5),
            data: tempData4,
          });
        }
      });

      this.chartdata = {
        labels: tempDataLabels.map(m => this.toNorwegianMonth(m)),
        datasets: tempData,
      };

      this.loaded = true;
    },

    initializeWidgets(filter) {
      this.loaded = false;
      Promise.all([
        userWidgetsService.fetchSoldProductsWidgets(filter),
      ]).then(() => {
        this.soldProd(this.soldProductsWidgets.items);
      });
    },

    toNorwegianMonth(englishMonth) {
      const date = new Date(Date.parse(`${englishMonth} 1, 2020`));
      return date.toLocaleDateString('nb-NO', { month: 'long' });
    },

    getFilterBy(value) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ];

      const today = new Date();
      const filterBy = [];

      for (let i = this.monthStart; i <= value; i++) {
        let month = (today.getMonth() - i);
        if (month <= 0) {
          month += 12;
        }
        filterBy.push(monthNames[month]);
      }
      return filterBy;
    },

    colorOpacity(color, opacity) {
      const opacityy = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + opacityy.toString(16).toUpperCase();
    },

    onResize() {
      if (window.innerWidth <= 1270) {
        this.options = this.chartOptions('top', 8);
      } else {
        this.options = this.chartOptions('left', 4);
      }
      if (this.loaded === true) {
        this.initializeWidgets(this.filterBySelected);
      }
    },

    chartOptions(legendPos = 'left', lengendBoxWidth = 4) {
      return {
        plugins: {
          datalabels: {
            display: true,
            align: 'center',
            anchor: 'center',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0, right: 0, top: 0, bottom: 0,
          },
        },
        legend: {
          display: true,
          position: legendPos,
          labels: {
            boxWidth: lengendBoxWidth,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: ((tooltipItem, data) => `${data.datasets[tooltipItem.datasetIndex].tooltip} - ${tooltipItem.yLabel}`),
          },
        },
      };
    },
  },

  mounted() {
    this.initializeWidgets();
  },

  created() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};



// WEBPACK FOOTER //
// ./src/app/components/widgets/soldProducts/soldProducts.js